import { createContext, useRef, useState } from "react";
import CustomToast from "../components/toast";
import BaseConfirmationModal from "./BaseConfirmationModal";

let timer;

export const ToastDataContext = createContext({})

export default function ToastDataContextManager(props) {

    const modalPromiseRef = useRef(null);

    const [toastData, setToastData] = useState({
        error: (message) => {
            if (timer) clearTimeout(timer);
            setMessage(message)
            setType("error")
            setShowToast(true);

            timer = setTimeout(() => {
                setShowToast(false);
                clearTimeout(timer);
            }, 3000)
        },
        success: (message) => {
            if (timer) clearTimeout(timer);
            setMessage(message)
            setType("success")
            setShowToast(true);

            timer = setTimeout(() => {
                setShowToast(false);
                clearTimeout(timer);
            }, 3000)
        },
        showConfirmationDialog: (message, title) => {
            setModalMessage(message);
            setModalTitle(title);
            setShowModal(true);
            return new Promise((resolve) => {
                modalPromiseRef.current = resolve
            })
        }

    })

    const [showToast, setShowToast] = useState(false)
    const [message, setMessage] = useState("")
    const [type, setType] = useState()

    const [showModal, setShowModal] = useState(false)
    const [modalMessage, setModalMessage] = useState("")
    const [modalTitle, setModalTitle] = useState("")

    const confirmationFunction = (state) => {
        setShowModal(false)
        if (!modalPromiseRef.current) return
        modalPromiseRef.current(state);
        modalPromiseRef.current = null;
    }

    return (
        <ToastDataContext.Provider value={toastData}>
            {props.children}
            <CustomToast show={showToast} type={type} message={message} />
            <BaseConfirmationModal message={modalMessage} title={modalTitle} showModal={showModal} onResolveConfirmation={confirmationFunction} />
        </ToastDataContext.Provider>
    )
}